export default __webpack_public_path__ + "static/media/paper-clip.276421b9.svg";